import React from 'react';

function DragIcon() {
    return (
        <svg width="25" height="10" viewBox="0 0 25 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 5L23.6667 5" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M19.6665 9L23.6665 5" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M19.6665 1L23.6665 5" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

export default DragIcon;
